import React from 'react';
import { Box } from '@mui/joy';
import { Tag } from '../Snippet';
import { useTranslation } from 'react-i18next';

const CellGeneric = ({ type, value, field }) => {
    const { t } = useTranslation()

    const getClassNameByValue = () => {
        switch (true) {
            case (value > 99):
                return "success"
            case (value > 80):
                return "good"
            case (value > 65):
                return "warning"
            default:
                return "danger"
        }
    }

    const label = type === 'scale_0_100' && typeof value === 'number'
        ? value
        : value
            ? typeof value === 'string'
                ? value
                : value[field]
            : undefined

    const additionalClass = type === 'scale_0_100' && typeof value === 'number'
        ? ` ${getClassNameByValue()}`
        : ''

    return (
        <Box className={`list-element-cell cell-generics cell-generics-${type}${additionalClass}`}>
            {label !== undefined
                ? type === 'scale_0_100' && typeof value === 'number'
                    ? <Tag color={getClassNameByValue()}>{label}</Tag>
                    : <span className="name" title={label}>{label}</span>
                : type !== 'scale_0_100' && <Tag color='warning'>{t('missing')}</Tag>
            }
        </Box>
    )
}

export default CellGeneric;